import { IonNote } from "@ionic/react";
import { useTranslation } from "react-i18next";
import type { AnyFieldApi } from "@tanstack/react-form";
import { getErrorText } from "@/components/atoms/form-ion/utils";

export type FormFieldInfoProps = {
  field: AnyFieldApi;
};

export function FormFieldInfo({
  field,
  ...props
}: React.ComponentProps<typeof IonNote> & FormFieldInfoProps) {
  const { i18n } = useTranslation();

  return field.state.meta.isTouched && field.state.meta.errors.length > 0 ? (
    <IonNote color="danger" {...props}>
      {getErrorText({
        language: i18n.language,
        errors: field.state.meta.errors,
      })}
    </IonNote>
  ) : props.children ? (
    <IonNote {...props} />
  ) : null;
}
